import { render, staticRenderFns } from "./SwitchStep.vue?vue&type=template&id=cc11d162"
import script from "./SwitchStep.vue?vue&type=script&lang=js"
export * from "./SwitchStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports